(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name espaiService
     *@description
     *Servicio de autores
     */

    angular
        .module('app')
        .factory('espaiService', espaiService);

    espaiService.$inject = ["$http","$filter","autorService","$q","$timeout"];

    function espaiService($http,$filter,autorService,$q,$timeout) {    
        //El ambit_id define si es un espai o una biografia o centro 

    	var espais = {
    		lang :1 ,
            lastLang:1,
            isSearch:false,
            data:[],
            cache : []
    	};

        espais.getEspaiByID = function(id)
        {
            for (var i = 0; i < espais.data.length; i++) {
                
                
                if(espais.data[i].id == id)
                {
                    return espais.data[i];
                }
            }
            return false;

        };

        espais.getSlug = function(espai)
        {
            var autor = autorService.getAutorByID(espai.data.autor);

            if(espai.data.ambit == 3)
                return "/"+language+"/autor/"+$filter('slugify')(autor.data.nom+' '+autor.data.cognoms);
            else            
                return "/"+language+'/espai/'+$filter('slugify')(espai.data.nom_ca)+"/"+$filter('slugify')(autor.data.nom+' '+autor.data.cognoms);
            
        };

        espais.getEspaiBySlugAutor = function(slug,autor)
        {
            for (var i = 0; i < espais.data.length; i++) {
                if(espais.data[i].data.autor == autor){
                    var nom = espais.data[i].data.nom_ca;
                
                    if($filter('slugify')(nom)==slug)
                    {
                        return espais.data[i];
                    }
                }
            }
        };

    	espais.getEspaiBySlug = function(slug)
    	{
    		for (var i = 0; i < espais.data.length; i++) {
    			var nom = espais.data[i].data.nom_ca;
    			
    			if($filter('slugify')(nom)==slug)
    			{
    				return espais.data[i];
    			}
    		}
    	};

    	espais.setLanguage = function(lang)
    	{
            if(espais.lang!=lang){
    		  espais.lang = lang;
            }
    	};

    	espais.getSearch = function(s,region)
    	{
    		var url= '/api/v1/predictive';
             return $http({
                method  : 'GET',
                url     : url,
                params :
                {
                	"search":s,
                	"lang":espais.lang,
                    "region":region
                }
                
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  
            	console.log(data.data);
                return data.data;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
    	};

    	espais.getEspaiContent = function(espai)
    	{
    		var url= '/api/v1/espai/'+espai+'/lang/'+espais.lang;
             return $http({
                method  : 'GET',
                url     : url,
                
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  
                data.data['espai_id']=espai;
            	console.log(data.data);
                return data.data;
            }

            function Failed(data){
                console.log(data);
                return false;
            }
    	};

        espais.getCentre = function()
        {

        };

        espais.invisibleAll = function()
        {
            var centres = espais.getCentres();
            for (var i = 0; i < centres.length; i++) {
                    console.log(centres[i]);
                    espais.setVisible(centres[i].data.nom_ca,false);
            }
        };

        espais.visibleAll = function()
        {
            var centres = espais.getCentres();
            for (var i = 0; i < centres.length; i++) {
                    console.log(centres[i]);
                    espais.setVisible(centres[i].data.nom_ca,true);
            }
        };

        espais.setVisible = function (centre,v)
        {
        	var autores = espais.getAutorsByCentre(centre);
        	for (var i = 0; i < autores.length; i++) {
        		autorService.setVisible(autores[i],v);
        	}
            	
        };

        espais.isVisible = function (centre)
        {
        	var b = false;
        	var autores = espais.getAutorsByCentre(centre);
        	for (var i = 0; i < autores.length; i++) {
        		 if(autorService.getAutorByID(autores[i]).visible)
        		 	b=true;
        	}
        	return b;
            	
        };

        espais.getAutorsByCentre = function(centre)
        {
        	var arr = [];
            for (var i = 0; i < espais.data.length; i++) {
                if(espais.data[i].data.ambit==4 ){
                    
                    if(espais.data[i].data.nom_ca==centre){
                        arr.push(espais.data[i].data.autor);
                    }
                }
            }
            console.log(arr);
            return arr; 

        };

        espais.getCentres = function()
        {
            var arr = [];
            for (var i = 0; i < espais.data.length; i++) {
                if(espais.data[i].data.ambit==4 ){
                    
                    if(arr.map(function(e) { return e.data.nom_ca; }).indexOf(espais.data[i].data.nom_ca)===-1){
                        arr.push(espais.data[i]);
                    }
                }
            }
            console.log(arr);
            return arr;   
        };

        espais.getCentresByAutor = function(id)
        {
            var arr = [];
            for (var i = 0; i < espais.data.length; i++) {
                if(espais.data[i].data.autor == id && espais.data[i].data.ambit==4 )
                    arr.push(espais.data[i]);
            }
            return arr;   
        };

        /**
        * @ngdoc method
        * @name getBiography
        * @memberof espaiService
        * @desciption
        * Obtienes las biografias y centros.
        */
        espais.getBiography = function(id)
        {
            var arr = [];
            for (var i = 0; i < espais.data.length; i++) {
                if(espais.data[i].data.autor == id && espais.data[i].data.ambit==3 )
                    arr.push(espais.data[i]);
            }
            return arr;   
        };
        /**
        * @ngdoc method
        * @name getByAutor
        * @memberof espaiService
        * @desciption
        * Obtienes los espais.
        */
    	espais.getByAutor = function(id)
    	{
    		var arr = [];

            if(!espais.data.length)
                return arr;

            

    		for (var i = 0; i < espais.data.length; i++) {
                
    			if(espais.data[i].data.autor == id && espais.data[i].data.ambit==1  )
                {
                    if( !espais.data[i].ruta.length ){
                        if(espais.isSearch){
                            if (espais.data[i].search) {
                                arr.push(espais.data[i]);
                            }
                        }else{
                            arr.push(espais.data[i]);
                        }
                    }
                }
    		}
            
            
    		return arr;
    	};
    	/**
        * @ngdoc method
        * @name getAutors
        * @memberof espaiService
        * @desciption
        * Obtienes los autores.
        */


        espais.load = false;


    	espais.getEspais = function (){
            var deferred = $q.defer();
            
            if(espais.data.length && espais.lang == espais.lastLang)
            {
                
                    $timeout(function(){
                        deferred.resolve(espais.data);
                    },20);
                
            }else{
                espais.load = true;
                var url= '/api/v1/espais';
                $http({
                    method  : 'GET',
                    url     : url,
                    params  : {
                        "lang":espais.lang
                    }
                
                
                })
                .then(Success)
                .catch(Failed);
            }
            
            function Success(data){  
                espais.load = false;
            	espais.data = data.data;
                espais.lastLang = espais.lang;

                deferred.resolve(data.data);
            }

            function Failed(data){
                console.log(data);
                deferred.reject(false);
            }

            return deferred.promise;

        };


    	return espais;
    }



})();
